import React from 'react';

const Footer = () => (
  <footer className="footer">
    <div className="container">
      <small><a href="https://github.com/JoeEcob/monzo-dashboard" title="View on GitHub">View on GitHub</a></small>
    </div>
  </footer>
);

export default Footer;



// WEBPACK FOOTER //
// ./src/components/Footer.js